import type {
  GTMEventGlycerinDisplayLink,
  GTMEventGlycerinLinkClick,
} from '@packages/tracking/src/types/events';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import { useCallback } from 'react';

export const useInstallmentCalculatorTracking = () => {
  const dispatchTracking = useTracking();

  const label = 'Kredit-Promo';

  /**
   * Track the display of the installment calculator link
   *
   * safe to use as Effect dependency
   * */
  const trackGlycerinDisplayLink = useCallback(() => {
    dispatchTracking<GTMEventGlycerinDisplayLink>({
      event: 'DisplayLink',
      DisplayLinkData: {
        category: 'Ratenelement',
        label,
        target: 'Overlay',
      },
    });
  }, [dispatchTracking]);

  /**
   * Track the click of the installment calculator link
   * */
  const trackGlycerinLinkClick = () => {
    dispatchTracking<GTMEventGlycerinLinkClick>({
      event: 'LinkClick',
      LinkClickData: {
        category: 'Ratenrechner',
        label,
      },
    });
  };

  return {
    trackGlycerinDisplayLink,
    trackGlycerinLinkClick,
  };
};
